(function () {
  window.TamburFormatMoney = function (cents) {
    var c = window.TamburCurrency || { iso: 'SEK', locale: 'sv' };
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(c.locale, {
        style: 'currency',
        currency: c.iso,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount + ' ' + c.iso;
    }
  };
})();
